import {Injectable} from '@angular/core';
import {IService} from '../IService';
import {PromotionTemplateModel} from '../../models/promotion-template.model';
import {HttpClientService} from '../httpClient/httpclient.service';
import {Observable} from 'rxjs/Observable';
import {map} from 'rxjs/operators';

@Injectable()
export class PromotionTemplateService extends IService<PromotionTemplateModel> {

  constructor(http: HttpClientService) {
    super(http, 'koncentro-promo', 'template');
  }

  create(model: PromotionTemplateModel): Observable<PromotionTemplateModel> {
    this.parseFromBooleanToChar(model);
    return super.create(model);
  }

  update(model: PromotionTemplateModel): Observable<PromotionTemplateModel> {
    this.parseFromBooleanToChar(model);
    return super.update(model);
  }

  get(id): Observable<PromotionTemplateModel> {
    return super.get(id).pipe(
      map((result) => {
        this.parseFromCharToBoolean(result)
        return result;
      })
    );
  }

  parseFromBooleanToChar(item) {
    if (item.flg_type_template !== null && item.flg_type_template !== undefined) {
      item.flg_type_template = item.flg_type_template === true ? '1' : '0';
    }
  }

  parseFromCharToBoolean(item) {
    if (item.flg_type_template) {
      item.flg_type_template = item.flg_type_template === '1';
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/services/promotion/promotion-template.service.ts